import {useTranslation} from "react-i18next";
import {useDispatch} from "react-redux";
import activitylogActions from "../../Actions/InternalCustomerAdmin/activityLogActions";
import commonActions from "../../Actions/commonActions";
import {Dropdown} from "../FormComponents/Dropdown";
import {FormInput} from "../FormComponents/Input/Input";
import {Button, ButtonOption} from "../Fundamentals/Button";
import React from "react";
import {DateInterval} from "../FormComponents/DateInterval";

export const EmailDeliveryLogsForm = ({ form, customer }) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const data = form?.data;
    const onSubmit = () => {
        dispatch(activitylogActions.searchFailedMails(data));
    }
    const onFieldChange = (value, field) => {
        dispatch(commonActions.changeMultiFormField(form.id, field, value));
    }

    const getCustomerEmails = () => {
        const emails = [customer.email, customer.contactPerson?.email].filter(Boolean);
        return [...new Set(emails)].map(email => ({ value: email, label: email }));
    }

    return (<div className="d-grid grid-cols-3">
        <fieldset className="d-grid gap-16">
            <div>
                {customer ? <Dropdown required={true} label={t("common.email")} options={getCustomerEmails()} value={data.value} valueProperty={'value'} property={"label"}
                                      onChange={(value) => onFieldChange(value, 'value')}/> :
                    <FormInput required={true} label={t("common.email")} value={data.value} onChange={(value) => onFieldChange(value, 'value')}/> }
            </div>
            <div>
                <label>{t("activitylogform.dateinterval")}</label>
                <DateInterval 
                    onChangeFromDate={(value) => onFieldChange(value, 'fromDate')}
                    onChangeToDate={(value) => onFieldChange(value, 'toDate')}
                    fromDateValue={data.fromDate}
                    toDateValue={data.toDate}
                />
            </div>
            <div className={"d-grid justify-content-start"}>
                <Button option={ButtonOption.PRIMARY} onClick={onSubmit}>{t("common.search")}</Button>
            </div>
        </fieldset>
        <fieldset className="d-grid gap-16 ml-24 mt-24">
            <div>{t("loggingContainer.emailDeliveryLogDescription")}</div>
        </fieldset>
    </div>)
}